var map = {
	"./activity/Router.js": 84198,
	"./activitybanner/Router.js": 74681,
	"./activitynotice/Router.js": 13911,
	"./benefit/Router.js": 67470,
	"./benefitcode/Router.js": 86298,
	"./brand/Router.js": 87597,
	"./calendar/Router.js": 22684,
	"./city/Router.js": 74249,
	"./coupon/Router.js": 98804,
	"./enterprise/Router.js": 29897,
	"./goods/Router.js": 97051,
	"./goodscategory/Router.js": 81894,
	"./goodsskucategory/Router.js": 12021,
	"./job/Router.js": 79899,
	"./member/Router.js": 30508,
	"./memberbenefit/Router.js": 66777,
	"./menu/Router.js": 85925,
	"./merchant/Router.js": 59726,
	"./password/Router.js": 93592,
	"./province/Router.js": 55678,
	"./role/Router.js": 14818,
	"./shop/Router.js": 32498,
	"./special/Router.js": 79642,
	"./suppliergoods/Router.js": 28367,
	"./trade/Router.js": 75615,
	"./user/Router.js": 68010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22616;